import { useState } from "react";
import {
  IconButton,
  Checkbox,
  Typography,
  Box,
  Card,
  List,
  Stack,
  ListItem,
  ListItemButton,
  ListItemText
} from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import moment from "moment";
import { useDispatch } from "react-redux";
import { setShowalert } from "../../../redux/actions/actions";
import { useSelector } from "react-redux";
import { English } from "../../../constant/EnglishFallback";

function TicketCard({ tickets, handleToggle }) {
  const [isExpanded, setIsExpanded] = useState(true);
  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.ResumeBuilder || {};
  const {
    TEXT_USER_TICKETS_INFO = English.ResumeBuilder.TEXT_USER_TICKETS_INFO,
    TEXT_NO_TICKETS_TO_PROFILE = English.ResumeBuilder.TEXT_NO_TICKETS_TO_PROFILE,
    TEXT_EXPIRED_TICKET_ALERT = English.ResumeBuilder.TEXT_EXPIRED_TICKET_ALERT
  } = LanguageData || {};

  const dispatch = useDispatch();
  const handleShowAlert = () => {
    let alertObj = {
      showAlert: true,
      title: "",
      text: TEXT_EXPIRED_TICKET_ALERT
    };
    dispatch(setShowalert(alertObj));
  };

  return (
    <Card className="pagelist-content" sx={{ p: 2 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">{TEXT_USER_TICKETS_INFO}</Typography>
        <IconButton color="primary" onClick={() => setIsExpanded((prev) => !prev)}>
          {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>

      {isExpanded && (
        <List disablePadding>
          {tickets.length > 0 ? (
            <Stack spacing={1} pt={1}>
              {tickets.map((ticket, index) => {
                const current = moment().format("YYYY-MM-DDThh:mm:ss");
                const isExpired = ticket?.expiry <= current && ticket?.expiry != null;
                return (
                  <Card
                    key={index.toString()}
                    className="pagelist-content"
                    sx={{ marginTop: "0px", padding: 0, cursor: "pointer" }}>
                    <ListItem
                      key={index.toString()}
                      alignItems="flex-start"
                      sx={{ m: 0, p: 0 }}
                      secondaryAction={
                        <Box>
                          {isExpired && (
                            <IconButton color="error" onClick={() => handleShowAlert()}>
                              <ErrorIcon fontSize="small" />
                            </IconButton>
                          )}
                          <Checkbox
                            edge="end"
                            onChange={() => handleToggle(ticket.id, "TicketCard")}
                            checked={ticket.isSelected}
                          />
                        </Box>
                      }>
                      <ListItemButton
                        onClick={() => handleToggle(ticket.id, "TicketCard")}
                        alignItems="flex-start"
                        sx={{ m: 0 }}>
                        <ListItemText
                          primary={<Typography variant="body1"> {ticket?.ticketType} </Typography>}
                          secondary={<Typography variant="body2">{ticket?.issuedBy}</Typography>}
                        />
                      </ListItemButton>
                    </ListItem>
                  </Card>
                );
              })}
            </Stack>
          ) : (
            <Typography>{TEXT_NO_TICKETS_TO_PROFILE}</Typography>
          )}
        </List>
      )}
    </Card>
  );
}

export default TicketCard;
